import { TileAddress } from "../address";
import { Cartesian2, Bounds } from "../../geometry";
import { TileViewBase } from "./tiles.map.view.base";
export class TileView extends TileViewBase {
    constructor(offset = 0) {
        super();
        this._offset = 0;
        this._offset = offset;
    }
    get offset() {
        return this._offset;
    }
    _doValidateContext(state, display, metrics, activAddresses, options) {
        if (state && display) {
            const offset = this._offset + (options?.zoomOffset ?? 0);
            const target = state.lod + offset;
            const lod = TileAddress.ClampLod(target, metrics);
            if (target != lod) {
                return;
            }
            let scale = state.scale;
            const nwTileXY = Cartesian2.Zero();
            const seTileXY = Cartesian2.Zero();
            const pixelCenterXY = metrics.getLatLonToPointXY(state.center.lat, state.center.lon, lod);
            const r = offset == 0 ? 1.0 : offset > 0 ? Math.pow(2, offset) : 1.0 / Math.pow(2, -offset);
            let w = (display?.resolution.width ?? 0) * r;
            let h = (display?.resolution.height ?? 0) * r;
            let rect = this._getRectangle(pixelCenterXY, w, h, scale, state.azimuth);
            let testRect = state.azimuth?.value ? this._getRectangle(pixelCenterXY, w, h, scale) : null;
            metrics.getPointXYToTileXYToRef(rect.xmin, rect.ymin, nwTileXY);
            metrics.getPointXYToTileXYToRef(rect.xmax, rect.ymax, seTileXY);
            const maxIndex = metrics.mapSize(lod) / metrics.tileSize - 1;
            const x0 = Math.max(0, nwTileXY.x);
            const y0 = Math.max(0, nwTileXY.y);
            const x1 = Math.min(maxIndex, seTileXY.x);
            const y1 = Math.min(maxIndex, seTileXY.y);
            const remains = new Array();
            const added = new Array();
            const tmp = new TileAddress(0, 0, lod);
            for (tmp.y = y0; tmp.y <= y1; tmp.y++) {
                for (tmp.x = x0; tmp.x <= x1; tmp.x++) {
                    if (testRect) {
                        const tileRect = this._getTileRectangle(tmp, metrics, pixelCenterXY, state.azimuth);
                        if (testRect.intersects(tileRect) == false) {
                            continue;
                        }
                    }
                    const key = tmp.quadkey;
                    const activ = activAddresses.get(key);
                    if (activ) {
                        remains.push(activ);
                        activAddresses.delete(key);
                        continue;
                    }
                    added.push(tmp.clone());
                }
            }
            let deleted = Array.from(activAddresses.values());
            activAddresses.clear();
            for (const a of remains) {
                activAddresses.set(a.quadkey, a);
            }
            for (const a of added) {
                activAddresses.set(a.quadkey, a);
            }
            if (options?.dispatchEvent ?? true) {
                if (deleted.length && this._removedObservable?.hasObservers()) {
                    this._removedObservable.notifyObservers(deleted, -1, this, this);
                }
                if (added.length && this._addedObservable?.hasObservers()) {
                    this._addedObservable.notifyObservers(added, -1, this, this);
                }
            }
        }
    }
    _getRectangle(center, w, h, scale, azimuth) {
        w = (w / scale) * 1.5;
        h = (h / scale) * 1.5;
        const x0 = center.x - w / 2;
        const y0 = center.y - h / 2;
        const bounds = new Bounds(x0, y0, w, h);
        return azimuth?.value ? Bounds.FromPoints2(...this._rotatePointsArround(center, azimuth, ...bounds.points())) : bounds;
    }
    _getTileRectangle(a, metrics, center, azimuth) {
        const points = [
            metrics.getTileXYToPointXY(a.x, a.y),
            metrics.getTileXYToPointXY(a.x + 1, a.y),
            metrics.getTileXYToPointXY(a.x + 1, a.y + 1),
            metrics.getTileXYToPointXY(a.x, a.y + 1),
        ];
        return Bounds.FromPoints2(...this._rotatePointsArround(center, azimuth, ...points));
    }
    *_rotatePointsArround(center, azimuth, ...points) {
        for (const p of points) {
            yield this._rotatePointArround(p.x, p.y, center, azimuth, p);
        }
    }
    _rotatePointArround(x, y, center, azimuth, target) {
        const r = target || Cartesian2.Zero();
        const translatedX = x - center.x;
        const translatedY = y - center.y;
        const cos = azimuth?.cos ?? 1;
        const sin = azimuth?.sin ?? 0;
        r.x = translatedX * cos - translatedY * sin + center.x;
        r.y = translatedX * sin + translatedY * cos + center.y;
        return r;
    }
}
//# sourceMappingURL=tiles.map.view.js.map